// https://gist.github.com/salimkayabasi/c291f3c275b9b024f4b5
google.maps.Marker.prototype.animateTo = function (newPosition, options) {
  const jQuery = window.jQuery;
  const defaultOptions = {
    duration: 1000,
    easing: 'linear',
    complete: null
  };
  options = options || {};

  // complete missing options
  Object.keys(defaultOptions).forEach((key) => {
    options[key] = options[key] || defaultOptions[key];
  });
  // throw exception if easing function doesn't exist
  if (options.easing !== 'linear' && (!jQuery || !jQuery.easing[options.easing])) {
    throw new Error(`
      "${options.easing}" easing function doesn't exist.
      Include jQuery and easing plugin and use the right function name.
      `);

  }

  // prefixed to avoid name collisions.
  // separate for lat/lng to avoid calling them in every frame
  this.AT_startPosition_lat = this.getPosition().lat();
  this.AT_startPosition_lng = this.getPosition().lng();
  const newLatitude = newPosition.lat();
  let newLongitude = newPosition.lng();

  // crossing the 180° meridian and going the long way around the earth?
  if (Math.abs(newLongitude - this.AT_startPosition_lng) > 180) {
    if (newLongitude > this.AT_startPosition_lng) {
      newLongitude -= 360;
    } else {
      newLongitude += 360;
    }
  }

  const animateStep = function (marker, startTime) {
    const ellapsedTime = Date.now() - startTime;
    const durationRatio = ellapsedTime / options.duration; // 0 - 1
    let easingDurationRatio = durationRatio;

    // use jQuery easing if it's not linear
    if (options.easing !== 'linear') {
      easingDurationRatio = jQuery.easing[options.easing](durationRatio, ellapsedTime, 0, 1, options.duration);
    }

    if (durationRatio < 1) {
      const deltaPosition = new google.maps.LatLng(
        marker.AT_startPosition_lat + ((newLatitude - marker.AT_startPosition_lat) * easingDurationRatio),
        marker.AT_startPosition_lng + ((newLongitude - marker.AT_startPosition_lng) * easingDurationRatio));
      marker.setPosition(deltaPosition);

      // use requestAnimationFrame if it exists on this browser. If not, use setTimeout with ~60 fps
      marker.AT_animationHandler = window.requestAnimationFrame ? window.requestAnimationFrame(() => {
        animateStep(marker, startTime);
      }) : setTimeout(() => {
        animateStep(marker, startTime);
      }, 17); // eslint-disable-line no-magic-numbers -- TODO: What is 17?

    } else {

      marker.setPosition(newPosition);

      if (typeof options.complete === 'function') {
        options.complete();
      }

    }
  };

  // stop possibly running animation
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(this.AT_animationHandler);
  } else {
    clearTimeout(this.AT_animationHandler);
  }

  animateStep(this, Date.now());
};
